export default __webpack_public_path__ + "static/media/helpdeskIconL.4ad65d67.svg";